export default class RotateDidConfirmationController {
  constructor($mdDialog) {
    'ngInject'
    this.$mdDialog = $mdDialog
  }

  close() {
    this.$mdDialog.destroy()
  }
}
